
export default function toKeyValueJsonArray(json, keyString, valueString) {
    var retour = {};
    if (json != null) {
        json.forEach(j => 
            retour[j[keyString]] = j[valueString]
        );
    }
    return retour;
}


// WEBPACK FOOTER //
// ./src/services/ToKeyValueJsonArray.js